module.exports = __webpack_public_path__ + "img/gear-J-high_188x188.ebc43506.png";